import Image from "next/image";
import { scrollToSectionElement } from "@/utils/scrollToSection";

export default function PageHero({
  webImageUrl = "",
  alt = "",
  scrollTargetRef = null,
}) {
  if (!webImageUrl) return null;

  const handleScroll = () => {
    if (!scrollTargetRef?.current) return;
    scrollToSectionElement(scrollTargetRef.current);
  };

  const isClickable = Boolean(scrollTargetRef);

  return (
    <Image
      src={webImageUrl}
      alt={alt}
      width={1920}
      height={480}
      priority
      quality={70}
      sizes="100vw"
      className={`standard-heroimg${isClickable ? " standard-heroimg--clickable" : ""}`}
      onClick={isClickable ? handleScroll : undefined}
      onKeyDown={
        isClickable
          ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                handleScroll();
              }
            }
          : undefined
      }
      role={isClickable ? "button" : undefined}
      tabIndex={isClickable ? 0 : undefined}
    />
  );
}
